import React from "react";
import loadable from "@loadable/component";

function Loading() {
    return <React.Fragment />;
}
export default loadable(
    () => import(/* webpackChunkName: 'loss_aversion_layer' */ "./LossAversionLayer"),
    {
        fallback: <Loading />,
    },
);
